



































































































































































































































































import { mapState } from 'vuex';
import { GPageBase } from '@/mixins';
import { Teacher } from '@/models/teacher/teacher';
import { mixins } from 'vue-class-component';
import { email, required } from 'vuelidate/lib/validators';
import { Component } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { StringUtils } from '@/utils/string.utils';
import { GEnum } from '@/constants/enum.defination';
import { GradeSchoolClass, SchoolClassSelection } from '@/models/school-class/school-class';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { TeacherPasswordRequest } from '@/models/teacher/teacher-password-request';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GVTag from '@/components/GVTag.vue';
import GSchoolClassCheckboxes from '@/components/GSchoolClassCheckboxes.vue';

@Component({
  name: 'GTeacherEdit',
  components: { GSchoolClassCheckboxes, GVTag, GCustomBreadCrumb },
  computed: {
    ...mapState(['account']),
  },
  methods: {},
  validations: {
    lastName: { required },
    firstName: { required },
    email: { required, email },
    password: { required },
    newPassword: { required },
    passwordConfirm: { required },
  },
})
export default class GGroupSetting extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  passwordModal: boolean = false;
  password: string = '';
  newPassword: string = '';
  passwordConfirm: string = '';
  selectionSchoolClasses: SchoolClassSelection[] = [];
  lazy: boolean = false;
  isTeacherDisable: boolean = false; // 教員無効化ボタン制御用。バインディングさせないために変数化

  async mounted() {
    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' },
      { title: this.$t('TEACHER_MANAGEMENT').toString(), icon: 'ios-school', routerPath: '/pages/teachers' },
      { title: this.$t('COMMON.EDIT', { value: this.$t('TEACHER_DETAIL').toString() }).toString() },
    ];

    teacherModule.clearTeacher();

    await teacherModule.fetchTeacherDetail(parseInt(this.$route.params.id));
    await schoolClassModule.fetchGradesSchoolClasses();

    schoolClassModule.gradeSchoolClasses.forEach((v: GradeSchoolClass, _: number) => {
      this.selectionSchoolClasses.push(new SchoolClassSelection(v.grade, teacherModule.teacher.schoolClasses, v.schoolClasses));
    });
    teacherModule.setSelectionSchoolClass(this.selectionSchoolClasses);
    this.isTeacherDisable = this.isOneself || !this.isLoginUserAdmin;

    this.lazy = true;
  }

  get nameOrder(): boolean {
    return this.$store.state.currentLanguage.nameOrder;
  }

  get gradeSchoolClasses(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClasses;
  }

  get lastName(): string {
    return teacherModule.teacher.lastName;
  }

  get firstName(): string {
    return teacherModule.teacher.firstName;
  }

  get email(): string {
    return teacherModule.teacher.email;
  }

  get role(): GEnum.Role {
    return teacherModule.teacher.role;
  }

  get teacher(): Teacher {
    return teacherModule.teacher;
  }

  get isLastNameRequired(): boolean {
    return this.$v.lastName.$dirty && !this.$v.lastName.required;
  }

  get isFirstNameRequired(): boolean {
    return this.$v.firstName.$dirty && !this.$v.firstName.required;
  }

  get isEmailRequired(): boolean {
    return this.$v.email.$dirty && !this.$v.email.required;
  }

  get isNotValidEmail(): boolean {
    return this.$v.email.$error && !this.$v.email.email;
  }

  get isOneself(): boolean {
    return this.$store.state.account.email === teacherModule.teacher.email;
  }

  get isLoginUserAdmin(): boolean {
    // Admin、IgsAdmin が管理者
    return this.$store.state.account.role === GEnum.Role.Admin || this.$store.state.account.role === GEnum.Role.IgsAdmin;
  }

  get roleAdmin(): GEnum.Role {
    return GEnum.Role.Admin;
  }

  get roleNormal(): GEnum.Role {
    return GEnum.Role.Normal;
  }

  get hasValidInput(): boolean {
    return !this.isLastNameRequired && !this.isFirstNameRequired && !this.isEmailRequired && !this.isNotValidEmail;
  }

  get hasRequiredInputs(): boolean {
    return this.lastName.length > 0 && this.firstName.length > 0 && this.email.length > 0;
  }

  get isEmptyPassword(): boolean {
    return this.$v.password.$dirty && this.$v.password.$invalid;
  }

  get isEmptyNewPassword(): boolean {
    return this.$v.newPassword.$dirty && this.$v.newPassword.$invalid;
  }

  get isNewPasswordOutOfRange(): boolean {
    return this.$v.newPassword.$dirty && this.$v.newPassword.$invalid == false && StringUtils.isValidPassword(this.newPassword) == false;
  }

  get isEmptyPasswordConfirm(): boolean {
    return this.$v.passwordConfirm.$dirty && this.$v.passwordConfirm.$invalid;
  }

  get isDifferentPassword(): boolean {
    return this.isEmptyNewPassword === false && this.isEmptyPasswordConfirm === false && this.newPassword !== this.passwordConfirm;
  }

  get isChangePasswordInvalid(): boolean {
    return (this.isEmptyPassword && !this.$store.state.account.isRoleIgsAdmin) || this.isEmptyNewPassword || this.isNewPasswordOutOfRange || this.isEmptyPasswordConfirm || this.isDifferentPassword;
  }

  get isSelectedSchoolClass(): boolean {
    return teacherModule.isSelectedSchoolClass;
  }

  makeFormTouched() {
    this.$v.lastName.$touch();
    this.$v.firstName.$touch();
    this.$v.email.$touch();
  }
  handleTeacherEditSubmit() {
    this.makeFormTouched();
    if (!this.hasValidInput || !this.hasRequiredInputs || (this.role === this.roleNormal && !this.isSelectedSchoolClass && this.teacher.isValidTrue)) {
      return;
    }

    this.teacher.isValid = this.convertRadioToBoolean(this.teacher.isValidRadio);
    teacherModule
      .updateTeacherDetail()
      .then((teacher: Teacher) => {
        this.showUpdateSuccessed();
      })
      .finally(() => {
        this.$router.push('/pages/teachers');
      });
  }

  handleSelectionSchoolClass(selectionSchoolClass: SchoolClassSelection[]) {
    teacherModule.setSelectionSchoolClass(selectionSchoolClass);
  }

  changePassword() {
    if (!this.$store.state.account.IgsAdmin) {
      this.$v.password.$touch();
    }
    this.$v.newPassword.$touch();
    this.$v.passwordConfirm.$touch();

    if (this.isChangePasswordInvalid) {
      return;
    }

    let params = {
      newPassword: this.newPassword,
    } as TeacherPasswordRequest;

    if (!this.$store.state.account.IgsAdmin) {
      params.password = this.password;
    }
    teacherModule
      .updateTeacherPassword(params)
      .then(
        _ => {
          this.showUpdateSuccessed();
          this.$router.push('/pages/teachers');
        },
        _ => {
          this.showUpdateFailed();
        }
      )
      .finally(() => {
        this.passwordModal = false;
        this.password = '';
        this.newPassword = '';
        this.passwordConfirm = '';
      });
  }
}
